import { StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../../application/UserProfile";
import { ColDef } from "../../grids/columns/colDef";
import { IRowCommandEventArgs } from "../../grids/controller";
import { RecordDataSource } from "../../grids/recordDataSource";
import { IGridSettings } from "../../grids/settings/gridSettingsService";
import { ContractService } from "../../../Contract/shared/ContractService";

export class RecordGridViewController {
  //static $inject = ["userProfile", "$state", "ContractService"];
  static $inject = ["userProfile", "$state"];

  gridDataSource!: RecordDataSource;
  gridSettings: IGridSettings | undefined;
  columns!: ColDef[];
  defaultSort: string | undefined;
  nameSingular: string = "";
  namePlural: string | undefined;
  showAddButton: boolean = false;
  showAddButtonPermission: string | string[] | undefined;
  onItemCommand: (args: IRowCommandEventArgs<unknown>) => void = () => {};
  onAddNew!: () => void;
  dropdownOptions: any[] = [];

  constructor(
    private readonly userProfile: UserProfile,
    private readonly $state: StateService,
    //private readonly contractService: ContractService
  ) {}

  $onInit() {
    if (!this.namePlural) {
      this.namePlural = `${this.nameSingular}s`;
    }
    if (this.onAddNew === undefined) {
      this.onAddNew = () => this.$state.go(".add");
    }
    // this.contractService.getDropdownOptions().then((options) => {
    //   console.log(options);
    //   this.dropdownOptions = options;
    // });
  }

  add() {
    this.onAddNew();
  }

  shouldShowAddButton(): boolean {
    if (!this.showAddButton) return false;
    const permission = this.showAddButtonPermission;
    if (!permission) return true;

    if (Array.isArray(permission)) {
      return permission.reduce<boolean>(
        (value, next) => value && this.userProfile.hasPermission(next),
        true
      );
    }

    return this.userProfile.hasPermission(permission);
  }
}
